import { RoleConstants } from "../components/Controls/EventConstants";
import { AideEnLigneFonction } from "../dto/GenApi.iNotPaie.Dto/AideEnLigneFonction";

export const routes = [
	{
		meta: {
			fonctionnalite: AideEnLigneFonction[AideEnLigneFonction.ADMINISTRATION_UTILISATEURS],
			roles: [RoleConstants.Administrateur, RoleConstants.AdministrateurPST, RoleConstants.WithoutPaie]
		},
		path: "/utilisateurs",
		name: "Utilisateurs",
		component: require("../components/utilisateurs/utilisateurs.vue.html")
	},
	{
		meta: {
			fonctionnalite: AideEnLigneFonction[AideEnLigneFonction.GENERAL_ACCUEIL],
			roles: [RoleConstants.Payeur, RoleConstants.Administrateur, RoleConstants.AdministrateurPST, RoleConstants.UtilisateurPST, RoleConstants.WithoutPaie]
		},
		path: "/DashBoard",
		name: "Home",
		component: require("../components/home/home.vue.html")
	},
	{
		meta: {
			fonctionnalite: AideEnLigneFonction[AideEnLigneFonction.SALARIE_NOTAIRES],
			roles: [RoleConstants.Payeur, RoleConstants.Administrateur, RoleConstants.AdministrateurPST, RoleConstants.UtilisateurPST, RoleConstants.WithoutPaie]
		},
		path: "/utilisateursnonsalaries",
		name: "Utilisateurs non salariés",
		component: require("../components/notaire/listeNotaire.vue.html")
	},
	{
		meta: {
			fonctionnalite: AideEnLigneFonction[AideEnLigneFonction.TRAITEMENT_DSN_CONTRAT_AUTO],
			roles: [RoleConstants.Payeur, RoleConstants.Administrateur, RoleConstants.AdministrateurPST, RoleConstants.UtilisateurPST, RoleConstants.WithoutPaie]
		},
		path: "/contratAutoFromDsn",
		name: "Import DSN",
		component: require("../components/contratAutoFromDsn/contratAutoFromDsn.vue.html")
	},
	{
		meta: {
			fonctionnalite: AideEnLigneFonction[AideEnLigneFonction.PARAMETRAGE_PARAMETRES_MODULE],
			roles: [RoleConstants.Administrateur]
		},
		path: "/parametrageModule",
		name: "Paramètres de module",
		component: require("../components/parametrageModule/parametrageModule.vue.html")
	},
	{
		meta: {
			roles: [RoleConstants.Administrateur, RoleConstants.AdministrateurPST]
		},
		path: "/listeTransfertSql",
		name: "Liste de transfert SQL",
		component: require("../components/listeTransfertSql/listeTransfertSql.vue.html")
	},
	{
		meta: {
			fonctionnalite: AideEnLigneFonction[AideEnLigneFonction.SALARIE_DEMANDE_ENTREE],
			roles: [RoleConstants.Administrateur, RoleConstants.AdministrateurPST, RoleConstants.UtilisateurPST]
		},
		path: "/listeEntreesSalarie",
		name: "Demandes d'entrées",
		component: require("../components/listeEntreesSalarie/listeEntreesSalarie.vue.html")
	},
	{
		meta: {
			fonctionnalite: AideEnLigneFonction[AideEnLigneFonction.SALARIE_DEMANDE_SORTIE],
			roles: [RoleConstants.Administrateur, RoleConstants.AdministrateurPST, RoleConstants.UtilisateurPST]
		},
		path: "/listeSortiesSalarie",
		name: "Demandes de sorties",
		component: require("../components/listeSortiesSalarie/listeSortiesSalarie.vue.html")
	},
	{
		meta: {
			fonctionnalite: AideEnLigneFonction[AideEnLigneFonction.SALARIE_ENTREE],
			roles: [RoleConstants.Administrateur, RoleConstants.AdministrateurPST, RoleConstants.UtilisateurPST]
		},
		path: "/entreeSalarie/:id",
		component: require("../components/entreeSalarie/entreeSalarie.vue.html"),
	},
	{
		meta: {
			fonctionnalite: AideEnLigneFonction[AideEnLigneFonction.SALARIE_SORTIE],
			roles: [RoleConstants.Administrateur, RoleConstants.AdministrateurPST, RoleConstants.UtilisateurPST]
		},
		path: "/sortieSalarie/:id",
		component: require("../components/sortieSalarie/sortieSalarie.vue.html"),
	},
	{
		meta: {
			fonctionnalite: AideEnLigneFonction[AideEnLigneFonction.SALARIE_LISTE],
			roles: [RoleConstants.Payeur, RoleConstants.Administrateur, RoleConstants.AdministrateurPST, RoleConstants.UtilisateurPST, RoleConstants.WithoutPaie]
		},
		path: "/listesalaries",
		name: "Salariés",
		component: require("../components/salaries/listeSalaries.vue.html")
	},
	{
		meta: {
			fonctionnalite: AideEnLigneFonction[AideEnLigneFonction.TRAITEMENT_PLANNING_ABSENCES],
			roles: [RoleConstants.Payeur, RoleConstants.Administrateur, RoleConstants.AdministrateurPST, RoleConstants.UtilisateurPST]
		},
		path: "/planningAbsences",
		name: "Planning des absences",
		component: require("../components/planningAbsences/planningAbsences.vue.html")
	},
	{
		meta: {
			fonctionnalite: AideEnLigneFonction[AideEnLigneFonction.TRAITEMENT_ELEMENTS_VARIABLES],
			roles: [RoleConstants.Payeur, RoleConstants.Administrateur, RoleConstants.AdministrateurPST, RoleConstants.UtilisateurPST]
		},
		path: "/saisieDesVariables",
		name: "Saisie des variables",
		component: require("../components/saisieDesVariables/saisieDesVariables.vue.html")
	},
	{
		meta: {
			fonctionnalite: AideEnLigneFonction[AideEnLigneFonction.EDITION_TABLEAUX],
			roles: [RoleConstants.Payeur, RoleConstants.Administrateur, RoleConstants.AdministrateurPST]
		},
		path: "/tableaux",
		name: "Tableaux",
		component: require("../components/tableaux/tableaux.vue.html")
	},
	{
		meta: {
			fonctionnalite: AideEnLigneFonction[AideEnLigneFonction.TRAITEMENT_CALCUL_PAIE],
			roles: [RoleConstants.Payeur, RoleConstants.Administrateur, RoleConstants.AdministrateurPST]
		},
		path: "/calculPaie",
		name: "Calculs et bulletins",
		component: require("../components/calculDePaie/calculDePaie.vue.html")
	},
	{
		meta: {
			fonctionnalite: AideEnLigneFonction[AideEnLigneFonction.SALARIE_NOUVEAU],
			roles: [RoleConstants.Payeur, RoleConstants.Administrateur, RoleConstants.AdministrateurPST, RoleConstants.UtilisateurPST, RoleConstants.WithoutPaie]
		},
		beforeEnter: (to, from, next) => {
			if (to.query && to.query.titre != null) {
				next();
			} else {
				next(false); // Empêche la navigation si le paramètre de requête n'est pas présent
			}
		},
		path: "/ficheSalarie/:id",
		component: require("../components/ficheSalarie/salarie.vue.html")
	},
	{
		meta: {
			fonctionnalite: AideEnLigneFonction[AideEnLigneFonction.EDITION_DOCUMENTS],
			roles: [RoleConstants.Payeur, RoleConstants.Administrateur, RoleConstants.AdministrateurPST, RoleConstants.UtilisateurPST]
		},
		path: "/documents",
		name: "Espace documentaire",
		component: require("../components/ged/documents.vue.html"),
	},
	{
		meta: {
			fonctionnalite: AideEnLigneFonction[AideEnLigneFonction.PARAMETRAGE_JOURS_NON_TRAVAILLES],
			roles: [RoleConstants.Payeur, RoleConstants.Administrateur, RoleConstants.AdministrateurPST]
		},
		path: "/joursNonTravailles",
		name: "Jours non travaillés",
		component: require("../components/joursFeries/joursFeries.vue.html"),
	},
	{
		meta: {
			fonctionnalite: AideEnLigneFonction[AideEnLigneFonction.PARAMETRAGE_PARAMETRES_RUBRIQUES],
			roles: [RoleConstants.Payeur, RoleConstants.Administrateur, RoleConstants.AdministrateurPST]
		},
		path: "/listeRubriques",
		name: "Rubriques",
		component: require("../components/rubriques/listeRubriques.vue.html")
	},
	{
		meta: {
			fonctionnalite: AideEnLigneFonction[AideEnLigneFonction.PARAMETRAGE_PARAMETRES_LIBELLES],
			roles: [RoleConstants.Payeur, RoleConstants.Administrateur, RoleConstants.AdministrateurPST]
		},
		path: "/libelles",
		name: "Libellés",
		component: require("../components/libelles/libelles.vue.html")
	},
	{
		meta: {
			fonctionnalite: AideEnLigneFonction[AideEnLigneFonction.PARAMETRAGE_SCENARIOS],
			roles: [RoleConstants.Payeur, RoleConstants.Administrateur, RoleConstants.AdministrateurPST]
		},
		path: "/scenarios",
		name: "Scénarios",
		component: require("../components/scenarios/scenarios.vue.html")
	},
	{
		meta: {
			fonctionnalite: AideEnLigneFonction[AideEnLigneFonction.PARAMETRAGE_PARAMETRES_SOCIETE],
			roles: [RoleConstants.Payeur, RoleConstants.Administrateur, RoleConstants.AdministrateurPST]
		},
		path: "/societe",
		name: "Société",
		component: require("../components/ficheSociete/ficheSociete.vue.html")
	},
	{
		meta: {
			fonctionnalite: AideEnLigneFonction[AideEnLigneFonction.PARAMETRAGE_CONTRAT_TYPE],
			roles: [RoleConstants.Payeur, RoleConstants.Administrateur, RoleConstants.AdministrateurPST]
		},
		path: "/contratType",
		name: "Contrat type",
		component: require("../components/contratType/contratType.vue.html")
	},
	{
		meta: {
			fonctionnalite: AideEnLigneFonction[AideEnLigneFonction.PARAMETRAGE_EXERCICE],
			roles: [RoleConstants.Payeur, RoleConstants.Administrateur, RoleConstants.AdministrateurPST, RoleConstants.WithoutPaie]
		},
		path: "/exercices",
		name: "Exercices",
		component: require("../components/exercices/exercices.vue.html")
	},
	{
		meta: {
			fonctionnalite: AideEnLigneFonction[AideEnLigneFonction.PARAMETRAGE_PARAMETRES_SPECIFIQUES],
			roles: [RoleConstants.Payeur, RoleConstants.Administrateur, RoleConstants.AdministrateurPST]
		},
		path: "/parametresSpecifiques",
		name: "Paramètres spécifiques",
		component: require("../components/parametresSpecifiques/parametresSpecifiques.vue.html")
	},
	{
		meta: {
			fonctionnalite: AideEnLigneFonction[AideEnLigneFonction.TRAITEMENT_DSN],
			roles: [RoleConstants.Payeur, RoleConstants.Administrateur, RoleConstants.AdministrateurPST]
		},
		path: "/dsn",
		name: "DSN",
		component: require("../components/dsn/dsn.vue.html")
	},
	{
		meta: {
			fonctionnalite: AideEnLigneFonction[AideEnLigneFonction.TRAITEMENT_GESTION_ABSENCES],
			roles: [RoleConstants.Salarie, RoleConstants.WithoutPaie]
		},
		path: "/gestionDesAbsences",
		name: "Gestion des absences",
		component: require("../components/gestionDesAbsences/gestionDesAbsences.vue.html")
	},
	{
		meta: {
			fonctionnalite: AideEnLigneFonction[AideEnLigneFonction.ADMINISTRATION_STATUS],
			roles: [RoleConstants.Administrateur, RoleConstants.AdministrateurPST]
		},
		path: "/healthCheck",
		name: "Statuts",
		component: require("../components/healthCheck/healthCheck.vue.html")
	},
	{
		meta: {
			fonctionnalite: AideEnLigneFonction[AideEnLigneFonction.REQUETEUR],
			roles: [RoleConstants.Payeur, RoleConstants.Administrateur, RoleConstants.AdministrateurPST]
		},
		path: "/requeteur",
		name: "Générateur de requête",
		component: require("../components/requeteur/requeteur.vue.html")
	},
	{
		meta: {
			fonctionnalite: AideEnLigneFonction[AideEnLigneFonction.REQUETEUR_MODIFIEUR],
			roles: [RoleConstants.Payeur, RoleConstants.Administrateur, RoleConstants.UtilisateurPST, RoleConstants.AdministrateurPST]
		},
		path: "/requeteurModifieur/:id",
		name: "Modifieur de requête",
		component: require("../components/requeteurModifieur/requeteurModifieur.vue.html")
	},
	{
		meta: {
			fonctionnalite: AideEnLigneFonction[AideEnLigneFonction.REQUETEUR_TABLE],
			roles: [RoleConstants.Payeur, RoleConstants.Administrateur, RoleConstants.AdministrateurPST, RoleConstants.UtilisateurPST, RoleConstants.WithoutPaie]
		},
		path: "/requeteurTable/:id",
		name: "Requeteur Table",
		component: require("../components/requeteurTable/requeteurTable.vue.html")
	},
	{
		meta: {
			fonctionnalite: AideEnLigneFonction[AideEnLigneFonction.ADMINISTRATION_HISTORIQUE_VARIABLES],
			roles: [RoleConstants.Payeur, RoleConstants.Administrateur, RoleConstants.UtilisateurPST, RoleConstants.AdministrateurPST]
		},
		path: "/historiqueVariables",
		name: "Variables sur la période",
		component: require("../components/historiqueVariables/historiqueVariables.vue.html")
	},
	{
		meta: {
			fonctionnalite: AideEnLigneFonction[AideEnLigneFonction.PARAMETRAGE_LISTE_SOCIETES],
			roles: [RoleConstants.Payeur, RoleConstants.Administrateur, RoleConstants.AdministrateurPST]
		},
		path: "/listeSocietes",
		name: "Liste sociétés",
		component: require("../components/listeSocietes/listeSocietes.vue.html")
	},
	{
		path: "/erreur/:id",
		name: "Erreur",
		component: require("../components/ecranErreur/erreurEcran.vue.html")
	},
	{
		meta: {
			fonctionnalite: "",
			roles: [RoleConstants.Payeur, RoleConstants.Administrateur, RoleConstants.AdministrateurPST]
		},
		path: "/dpae",
		name: "Demandes DPAE",
		component: require("../components/dpae/dpae.vue.html")
	},
	{
		meta: {
			fonctionnalite: '',
			roles: [RoleConstants.Payeur, RoleConstants.Administrateur, RoleConstants.UtilisateurPST, RoleConstants.AdministrateurPST]
		},
		path: "/envoiBulletins",
		name: "Envoi sécurisé des bulletins",
		component: require("../components/Primobox/envoiBulletins/envoiBulletins.vue.html")
	}
];



// WEBPACK FOOTER //
// ./src/router/routes.ts